import BUSD_ABI from "../Contracts/BUSD_ABI.json";
import contractABI from "../Contracts/contract_ABI.json";
import tokenABI from "../Contracts/Token_ABI.json";
import ATMTokenABI from "../Contracts/ATMTokenABI.json";

// const arr  = {contract:"0x7928986fe9728c35cD49a0240281f03351Ce5672",contractABI:contractABI,BUSD:"0xe37b70Ef457899F0afdFB71CEd2671CFA84ef770",BUSD_ABI:BUSD_ABI}
///===========testnet============/////////////
const arr = {
  contract: "0x185CC8F3C78eC6e440aB221ef71ba38971eB5585",
  contractABI: contractABI,
  BUSD: "0x55d398326f99059fF775485246999027B3197955",
  BUSD_ABI: BUSD_ABI,

  token: "0xFb9b2886a8e47CC6AAa85c73A15Ef1B6c9864F35",
  tokenABI: tokenABI,
  ATMToken: "0x55d398326f99059fF775485246999027B3197955",
  ATMTokenABI: ATMTokenABI,
};

////////////////mainnet//////////////////
// const arr = {
//   contract: "0x8DFEc23786Da689a229f4867C1E5A4EEA6f3AE11",
//   contractABI: contractABI,
//   BUSD: "0x55d398326f99059fF775485246999027B3197955",
//   BUSD_ABI: BUSD_ABI,//currently using this

//   token: "0x55d398326f99059fF775485246999027B3197955",
//   tokenABI: tokenABI,
//   ATMToken:"0x55d398326f99059fF775485246999027B3197955",
//   ATMTokenABI:ATMTokenABI,
// };

export const ContractDetails = arr;

// Action creators are generated for each case reducer function

export default ContractDetails;
